// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"NewsletterSignup_mainWrapper__OVqJF","formContainer":"NewsletterSignup_formContainer__ZtMx1","submit":"NewsletterSignup_submit__A20gC"};